import RecommendationFlightsComponent from "../RecommendationFlightsComponent";
import RecommendationPricesComponent from "../RecommendationPricesComponent";

import { Wrapper } from "./style";

const RecommendationComponent = ({ recommendation }) => (
  <Wrapper id={`rec-${recommendation.rec_id}`}>
    <RecommendationFlightsComponent recommendation={recommendation} />
    <RecommendationPricesComponent recommendation={recommendation} />
  </Wrapper>
);

export default RecommendationComponent;
